import { Navigate } from "react-router-dom";
import { getCurrentUser } from "../utils/auth.js";

export default function ProtectedRoute({ children, role }) {
  const user = getCurrentUser();

  if (!user) return <Navigate to="/login" replace />;


  const userRole = user.admin ? "admin" : "seller";

  if (role && role !== userRole) return <Navigate to={`/${userRole}`} replace />;

  return children;
}
